import { render, staticRenderFns } from "./TrMantenimientoGeneral.vue?vue&type=template&id=76e9ec64"
import script from "./TrMantenimientoGeneral.vue?vue&type=script&lang=js"
export * from "./TrMantenimientoGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports